<template>
    <div 
      class="mt-4">
      <v-layout wrap>
        <v-flex>
          <v-snackbar
              v-model="dialog.snackbar"
              top
              right
              color="green">
              <span 
                class="body-1 font-weight-light white--text"
                v-html="message.success">
              </span>
    
              <template v-slot:action="{ attrs }">
                <v-btn
                  icon
                  color="white"
                  class="body-1 font-weight-bold text-capitalize"
                  v-bind="attrs"
                  @click="dialog.snackbar = false">
                  <v-icon>mdi-close-circle-outline</v-icon>
                </v-btn>
              </template>
            </v-snackbar>
          <section>
            <v-row
              class="pa-4 pb-0 pt-0">
              <v-col
                cols="12" class="pb-1 pt-1">
                <v-card
                  flat
                  style="cursor: pointer;"
                  color="#ffffff">
                  <v-card-text>
                    <div
                      class="d-flex align-center">
                      <div
                        class="d-flex align-center">
                        <v-icon
                          size="24"
                          :color="set_color">
                          mdi-menu
                        </v-icon>
    
                        <div
                          class="fs-16 black--text ml-3"
                          style="font-weight: 600; padding-top: 1px;">
                          {{ $route.meta.title }}
                        </div>
                      </div>
    
                    </div>
                  </v-card-text>
                  <v-card 
                    flat
                    style="background-color: transparent;">
                    <v-card-text class="pa-0">
                      <v-card flat 
                        style="border-radius: 0px 0px 6px 6px;">
                        <div :style="{ 'background-color': `${set_color}4a` }" class="d-flex align-center pa-3 justify-center" style="opacity: .7;">
  
                          <div class="text-center fs-16 mx-5" style="font-weight: 700; cursor: pointer;" :style="selected.view === 0 ? 'background-color: #ffffff; border-radius: 6px; padding: 10px 10px;' : ''" @click="selected.view = 0; update_status = false;">
                            <v-icon size="24" :color="selected.view === 0 ? set_color : '#424242'">mdi-book-open</v-icon>
                            <div class="mt-2 fs-12" :style="{ 'color': selected.view === 0 ? set_color : '#424242' }">Aduan Pengguna</div>
                          </div>
        
                          <div class="text-center fs-16 mx-5" style="font-weight: 700; cursor: pointer;" :style="selected.view === 1 ? 'background-color: #ffffff; border-radius: 6px; padding: 10px 10px;' : ''" @click="selected.view = 1; update_status  = false;">
                            <v-icon size="24" :color="selected.view === 1 ? set_color : '#424242'">mdi-frequently-asked-questions</v-icon>
                            <div class="mt-2 fs-12" :style="{ 'color': selected.view === 1 ? set_color : '#424242' }">Pertanyaan Sering Muncul</div>
                          </div>

                          <div class="text-center fs-16 mx-5" style="font-weight: 700; cursor: pointer;" :style="selected.view === 2 ? 'background-color: #ffffff; border-radius: 6px; padding: 10px 10px;' : ''" @click="selected.view = 2; update_status  = false;">
                            <v-icon size="24" :color="selected.view === 2 ? set_color : '#424242'">mdi-card-account-phone</v-icon>
                            <div class="mt-2 fs-12" :style="{ 'color': selected.view === 1 ? set_color : '#424242' }">Konfigurasi Kontak Admin</div>
                          </div>
  
                        </div>
                      </v-card>
                    </v-card-text>
                  </v-card>
                </v-card>
              </v-col>
            </v-row>
  
            <v-row
              class="pa-4">
              <v-col 
                cols="12"
                class="py-0">
                <v-card 
                  flat
                  style="background-color: transparent;">
                  <v-card-text class="pa-0">
                    <v-card flat 
                      style="border-radius: 6px;">
                      <v-card-text>
                        <div v-if="selected.view === 0">
                          <div class="d-flex align-center justify-space-between">
                            <div class="black--text fs-13" style="font-weight: 600;">
                              Aduan Pengguna
                            </div>
  
                            <div>
                              <v-btn
                                :color="set_color"
                                elevation="0"
                                small
                                v-if="!update_status"
                                @click="reset()"
                                class="white--text text-capitalize">
                                Ubah
                              </v-btn>
  
                              <v-btn
                                :color="set_color"
                                elevation="0"
                                small
                                v-if="update_status"
                                @click="save()"
                                class="white--text text-capitalize">
                                Simpan
                              </v-btn>
                              <v-btn
                                :color="'red'"
                                elevation="0"
                                small
                                outlined
                                v-if="update_status"
                                @click="update_status = false"
                                class="text-capitalize ml-2">
                                Batal
                              </v-btn>
                            </div>
                          </div>
                          <v-divider class="my-3"></v-divider>
  
                          <div v-if="process.load">
                            <v-card-text
                              v-if="process.load" 
                              class="pb-0 my-4" 
                              style="height: calc(100vh - 350px); display: flex; align-items: center; justify-content: center;">
                              <div class="text-center">
                                <div class="mb-4 title">
                                  Mohon Tunggu . . .
                                </div>
              
                                <v-progress-linear
                                  :color="set_color"
                                  indeterminate
                                  rounded
                                  height="10">
                                </v-progress-linear>
                              </div>
                            </v-card-text>
                          </div>
  
                          <div v-if="!process.load">
                            <div v-if="!update_status">
                              <div class="fs-12">
                                <div class="fs-12" v-html="detail.panduan"></div>
                              </div>
                            </div>
  
                            <div v-if="update_status">
                              <quill-editor 
                                ref="myTextEditor"
                                :options="{
                                  placeholder: 'Contoh. Tuliskan Syarat dan Ketentuan disini . . .',
                                }"
                                v-model="form.panduan">
                              </quill-editor>
                            </div>
                          </div>
                        </div>
  
                        <div v-if="selected.view === 1">
                          <div class="d-flex align-center justify-space-between">
                            <div class="black--text fs-13" style="font-weight: 600;">
                              Pertanyaan Sering Muncul
                            </div>
  
                            <div>
                              <v-btn
                                :color="set_color"
                                elevation="0"
                                small
                                v-if="!update_status"
                                @click="reset()"
                                class="white--text text-capitalize">
                                Ubah
                              </v-btn>
  
                              <v-btn
                                :color="set_color"
                                elevation="0"
                                small
                                v-if="update_status"
                                @click="save()"
                                class="white--text text-capitalize">
                                Simpan
                              </v-btn>
                              <v-btn
                                :color="'red'"
                                elevation="0"
                                small
                                outlined
                                v-if="update_status"
                                @click="update_status = false"
                                class="text-capitalize ml-2">
                                Batal
                              </v-btn>
                            </div>
                          </div>
                          <v-divider class="my-3"></v-divider>
  
                          <div v-if="process.load">
                            <v-card-text
                              v-if="process.load" 
                              class="pb-0 my-4" 
                              style="height: calc(100vh - 350px); display: flex; align-items: center; justify-content: center;">
                              <div class="text-center">
                                <div class="mb-4 title">
                                  Mohon Tunggu . . .
                                </div>
              
                                <v-progress-linear
                                  :color="set_color"
                                  indeterminate
                                  rounded
                                  height="10">
                                </v-progress-linear>
                              </div>
                            </v-card-text>
                          </div>
  
                          <div v-if="!process.load">
                            <div v-if="!update_status">
                              <div class="fs-12">
                                <div class="fs-12">
                                  <div v-for="(item, index) in detail.faq" :key="index" class="d-flex mb-3">
                                    <div class="fs-14 font_weight_600 pr-2" style="padding-top: 2px;">
                                      {{ index + 1 }}.
                                    </div>
                                    <div class="ml-2 fs-14 font_weight_600" style="padding-top: 2px;">
                                      <div>
                                        {{ item.title }}
                                      </div>

                                      <div class="mt-2">
                                        {{ item.desc }}
                                      </div>
                                    </div>
                                  </div>  
                                </div>
                              </div>
                            </div>
  
                            <div v-if="update_status">
                              <div class="mb-2">
                                <v-btn
                                  :color="set_color"
                                  elevation="0"
                                  small
                                  @click="form.faq.push({ title: '', desc: '' })"
                                  class="white--text text-capitalize">
                                  Tambah
                                </v-btn>
                              </div>
                              <div v-for="(item, index) in form.faq" :key="index">
                                <ValidationObserver 
                                  ref="form">
                                  <v-form>
                                    <div class="d-flex mb-2">
                                      <div class="fs-14 font_weight_600 pr-2" style="padding-top: 2px;">
                                        {{ index + 1 }}.
                                      </div>
                                      <div class="" style="padding-top: 2px; width: 100%;">
                                        <v-card
                                          flat
                                          style="border-radius: 6px; border: 1px dashed #eee;">
                                          <v-card-text class="py-2">
                                            <div class="d-flex justify-space-between">
                                              <div style="width: 80%;">
                                                <ValidationProvider 
                                                  name="`Judul ${index + 1}`" 
                                                  rules="required" 
                                                  v-slot="{ errors }">
                                                  <div class="fs-13 mb-1 black--text">
                                                    Judul
                                                  </div>
        
                                                  <v-text-field
                                                    v-on:keyup.enter="save()"
                                                    
                                                    solo
                                                    rounded
                                                    dense
        
                                                    :color="set_color"
                                                    placeholder="Judul"
                                                    v-model="item.title"
                                                    :error-messages="errors"
                                                    required
                                                    style="border-radius: 6px; width: 100%;"
                                                    class="mb-0">
                                                  </v-text-field>
                                                </ValidationProvider>
                                              </div>
                                              <div>
                                                <v-btn
                                                  @click="form.faq.splice(index, 1)"
                                                  min-width="25"
                                                  height="25"
                                                  x-small
                                                  rounded
                                                  color="#e7515a"
                                                  elevation="0"
                                                  class="white--text text-capitalize ml-2 px-0"
                                                  style="font-weight: 600; border-radius: 8px;">
                                                  <v-icon size="13">mdi-trash-can-outline</v-icon>
                                                </v-btn>
                                              </div>
                                            </div>
    
                                            <ValidationProvider 
                                              name="`Deskripsi ${index + 1}`" 
                                              rules="required" 
                                              v-slot="{ errors }">
                                              <div class="fs-13 mb-1 black--text">
                                                Deskripsi
                                              </div>
    
                                              <v-textarea
                                                v-on:keyup.enter="save()"
                                                
                                                solo
                                                rounded
                                                dense
                                                rows="3"
    
                                                :color="set_color"
                                                placeholder="Deskripsi"
                                                v-model="item.desc"
                                                :error-messages="errors"
                                                required
                                                style="border-radius: 6px; width: 100%;"
                                                class="mb-4">
                                              </v-textarea>
                                            </ValidationProvider>
                                          </v-card-text>
                                        </v-card>
                                      </div>
                                    </div>
                                  </v-form>
                                </ValidationObserver>
                              </div>
                            </div>
                          </div>
  
                        </div>

                        <div v-if="selected.view === 2">
                          <div class="d-flex align-center justify-space-between">
                            <div class="black--text fs-13" style="font-weight: 600;">
                              Konfigurasi Kontak Admin
                            </div>
  
                            <div>
                              <v-btn
                                :color="set_color"
                                elevation="0"
                                small
                                v-if="!update_status"
                                @click="reset()"
                                class="white--text text-capitalize">
                                Ubah
                              </v-btn>
  
                              <v-btn
                                :color="set_color"
                                elevation="0"
                                small
                                v-if="update_status"
                                @click="save()"
                                class="white--text text-capitalize">
                                Simpan
                              </v-btn>
                              <v-btn
                                :color="'red'"
                                elevation="0"
                                small
                                outlined
                                v-if="update_status"
                                @click="update_status = false"
                                class="text-capitalize ml-2">
                                Batal
                              </v-btn>
                            </div>
                          </div>
                          <v-divider class="my-3"></v-divider>
  
                          <div v-if="process.load">
                            <v-card-text
                              v-if="process.load" 
                              class="pb-0 my-4" 
                              style="height: calc(100vh - 350px); display: flex; align-items: center; justify-content: center;">
                              <div class="text-center">
                                <div class="mb-4 title">
                                  Mohon Tunggu . . .
                                </div>
              
                                <v-progress-linear
                                  :color="set_color"
                                  indeterminate
                                  rounded
                                  height="10">
                                </v-progress-linear>
                              </div>
                            </v-card-text>
                          </div>
  
                          <div v-if="!process.load">
                            <div v-if="!update_status">
                              <div class="fs-12">
                                <div class="fs-12">
                                  <div class="d-flex align-center mb-2">
                                    <div>
                                      <v-icon size="18" :color="set_color">mdi-email-outline</v-icon>
                                    </div>
                                    <div class="ml-2 fs-14 font_weight_600" style="padding-top: 2px;">
                                      {{ detail.email }}
                                    </div>
                                  </div>
  
                                  <div class="d-flex align-center">
                                    <div>
                                      <v-icon size="18" :color="set_color">mdi-phone-outline</v-icon>
                                    </div>
                                    <div class="ml-2 fs-14 font_weight_600" style="padding-top: 2px;">
                                      {{ detail.phone }}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
  
                            <div v-if="update_status">
                              <ValidationObserver 
                                ref="form">
                                <v-form>
                                  <ValidationProvider 
                                    name="Email" 
                                    rules="email" 
                                    v-slot="{ errors }">
                                    <div class="fs-13 mb-1 black--text">
                                      Email
                                    </div>

                                    <v-text-field
                                      v-on:keyup.enter="save()"
                                      
                                      solo
                                      rounded
                                      dense

                                      :color="set_color"
                                      placeholder="Email"
                                      v-model="form.email"
                                      :error-messages="errors"
                                      required
                                      style="border-radius: 6px; width: 40%;"
                                      class="mb-4">
                                    </v-text-field>
                                  </ValidationProvider>


                                  <ValidationProvider 
                                    name="Telepon" 
                                    rules="min:9|max:13" 
                                    v-slot="{ errors }">
                                    <div class="body-2 mb-2">
                        
                                      Mobilephone
                                    </div>

                                    <v-text-field
                                      v-on:keyup.enter="save()"
                                      
                                      solo
                                      rounded
                                      dense
                                      prefix="+62"

                                      onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                                      type="number"
                                      min="0"

                                      :color="set_color"
                                      placeholder="81XXXXXXXXX"

                                      v-model="form.phone"
                                      :error-messages="errors"
                                      required
                                      style="border-radius: 6px; width: 30%;">
                                    </v-text-field>
                                  </ValidationProvider>
                                </v-form>
                              </ValidationObserver>
                            </div>
                          </div>
  
                        </div>
                      </v-card-text>  
                    </v-card>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </section>
        </v-flex>
      </v-layout>
    </div>
  </template>
  
  
  <script>
  import { TokenService } from "@/service/Storage.Service";
  import { get, post, put, patch, destroy } from "@/service/Axios";
  import moment from "moment"
  import "moment/locale/id"
  export default {
    data () {
      return {
        filter: {
          school_id: '',
        },
        selected: {
          view: 0
        },
        dialog: {
          snackbar: false,
          fullscreen: false,
          form: false
        },
        update_status: false,
        form: {
          id: '',
          syarat_ketentuan: '',
          company_name: '',
          logo: '',
          fav_icon: '',
          color: '',
          kebijakan_privasi: '',
          panduan: '',
          faq: [],
          email: '',
          phone: '',
        },
        school: [],
  
        detail: {},
  
        process: {
          load: false,
          image: false,
          form: false
        },
        message: {
          success: '',
          error: ''
        }
      }
    },
    components: {
    },
    watch: {
      // 'options': {
      //   handler () {
      //     let pagination = { row: this.limit, page: 1 }
          
      //     this.fetch(pagination)
      //   },
      //   deep: true
      // }
    },
    computed: {
      token () {
        return this.$store.state.token
      },
      user () {
        this.filter.school_id = this.$store.state.user.school_id === undefined || this.$store.state.user.school_id === null ? this.$store.state.school !== undefined && this.$store.state.school !== null && this.$store.state.school !== '' ? this.$store.state.school : '' : this.$store.state.user.school_id
        return this.$store.state.user
      },
      set_color () {
        return this.$store.state.color
      }
    },
    mounted () {
      this.fetchDetail()
    },
    methods: {
      async fetchDetail() {
          this.process.load = true
         let params = {
        }
        let url = this.$store.state.user.school_id !== undefined && this.$store.state.user.school_id !== null ? 'pegawai/config/data' : 'config/data'
  
        await get(`${url}`, { params })
        .then(response => {
          let res = response.data
          
          if (res.status === 200) {
            this.detail = res.results.data[0]
            this.detail.faq = this.detail.faq === '' ? [] : JSON.parse(this.detail.faq)
  
            this.process.load = false
          }
        })
      },
  
      reset () {
        this.update_status = true
        this.form.syarat_ketentuan = this.detail.syarat_ketentuan
        this.form.kebijakan_privasi = this.detail.kebijakan_privasi
        this.form.company_name = this.detail.company_name
        this.form.logo = this.detail.logo
        this.form.fav_icon = this.detail.fav_icon
        this.form.color = this.detail.color
        this.process.form = false
        this.form.id = this.detail.id,
        this.form.panduan = this.detail.panduan,
        this.form.faq = this.detail.faq === '' ? [] : this.detail.faq
        this.form.email = this.detail.email
        this.form.phone = this.detail.phone
      },
      async save () {
        this.message.error = ''
        this.process.form = true
    
        let url = this.$store.state.user.school_id !== undefined && this.$store.state.user.school_id !== null ? 'pegawai/config/update' : 'config/update'
  
        // SAVE TO REST API
        await post(url, {
          data: {
            id: this.form.id,
            syarat_ketentuan: this.form.syarat_ketentuan,
            kebijakan_privasi: this.form.kebijakan_privasi,
            company_name: this.form.company_name,
            logo: this.form.logo,
            fav_icon: this.form.fav_icon,
            color: this.form.color,
            panduan: this.form.panduan,
            faq: this.form.faq.length < 1 ? '' : JSON.stringify(this.form.faq),
            email: this.form.email,
            phone: this.form.phone
          }
        })
        .then(response => {
          let res = response.data
          
          this.process.form = false
  
          if (res.status === 200) {
            this.dialog.form = false
  
            this.dialog.snackbar = true
            this.message.success = res.message
  
            this.dialog.fullscreen = false
  
            this.fetchDetail()
            this.update_status = false
  
          } else {
            this.message.error = res.message
          }
        })
      }
    },
    created () {
    }
  }
  </script>